export enum DashboardItemType {
    Product = "product", Minibox = "minibox", Thumbnail = "thumbnail", Content = "content",
}

export enum DashboardSectionType {
    Homepage = "homepage", Mixed = "mixed",
}

export default { DashboardItemType, DashboardSectionType };
